import React from 'react';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import {Link} from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import getUploadIconAndStatus from '../../../../SignerUi/utils/getUploadIconAndStatus';
import {BorderedTextLabel} from '../../../../Core/company/labels/BorderedTextLabel/BorderedTextLabel';
import './attachment.less';

export default function Attachment({
    attachment = {},
    onClick
}) {
    const intl = useIntl();
    const {attachmentId} = useParams();
    const {icon, status} = getUploadIconAndStatus(attachment);
    const isSelected = attachment.id === attachmentId;

    return (
        <ListItem
            button
            disableGutters
            component={Link}
            to={`attachment/${attachment.id}`}
            onClick={onClick}
            selected={isSelected}
            classes={{root: 'signing-menu-attachment-container'}}
            data-wdio={`test-menu-attachment-${attachment.id}`}
        >
            <div className="signing-menu-attachment-info">
                <div className="name-container">
                    <div className="name">
                        {attachment.name}
                        {attachment.is_required ? (
                            <BorderedTextLabel className="optional-label">
                                {intl.formatMessage({
                                    id: 'oss.components.SideBar.Uploads.required',
                                    defaultMessage: ''
                                })}
                            </BorderedTextLabel>
                        ) : (
                            <BorderedTextLabel className="optional-label">
                                {intl.formatMessage({
                                    id: 'oss.components.SideBar.Document.optional',
                                    defaultMessage: ''
                                })}
                            </BorderedTextLabel>
                        )}
                    </div>
                </div>
                <div className="status-container">
                    {icon}
                    <div className="status">
                        {intl.formatMessage({id: status, defaultMessage: ''})}
                    </div>
                </div>
                {attachment.description && (
                    <div className="description">
                        {attachment.description}
                    </div>
                )}
            </div>
        </ListItem>
    );
}
